import React from 'react';

export default function TD({ item, borderRight, borderBottom }) {
  return (
    <td
      className='type'
      style={{
        color: item.color,
        fontWeight: (item.amount !== 0) ? 'bold' : 'normal',
        borderRight: borderRight && '1px solid rgb(203, 203, 203)',
        borderBottom: borderBottom && '1px solid rgb(203, 203, 203)',
        backgroundColor: item.backgroundColor || '#e1e1e1',
        maxHeight: '9px',
        height: '9px',
        fontSize: item.size || '12px',
      }}
    >
      {Math.round(item.amount)}
    </td>
  );
}
